<template>
  <v-card
    class="mx-n3 mx-sm-16 px-0 px-sm-4 px-md-8 flex-fill align-self-start"
    max-width="720"
    flat
    tile
    outlined
  >
    <v-card-text class="pt-6">
      <p class="text-center font-weight-black text-h6 black--text">강의실 입장은 신청하신 차수의 18:30 부터 입장이 가능합니다.</p>

      <div class="box1 mx-n4 pa-4">
        <p class="text-center font-weight-black f1 cyan--text">2023년 일차의료기관 감염병 대응 온라인 연수교육 비공개 방침 안내</p>
        <p>본 심포지엄의 온라인 동영상은 비공개 자료이며, 저작권은 협회 및 연자에게 있습니다.</p>
        <p>
          영상자료를 다운받거나 녹화하는 행위는 저작권법에 위배되며,<br>
          무단 녹화 및 배포로 발생하는 저작권법 문제와 관련하여서는 민형사상의 책임을 강력하게 물을 예정입니다.<br>
          이 점 각별히 유의하여 주시기 바랍니다.
        </p>
        <p class="font-weight-black red--text">※ 온라인 강의 시청 시 유의사항</p>
        <p>
          - 온라인 강의는 ‘크롬브라우저’를 이용해  시청하시는 것을 권장드립니다.<br>
          - 방송 시청 중 화면이 끊기거나, 소리가 갑자기 들리지 않을 경우에는 새로고침(F5)을 클릭해주세요.
        </p>
      </div>

      <p class="text-center my-4">위 내용에 동의하신 후 온라인 강의 시청이 가능합니다.</p>

      <!--  form 박스  -->
      <v-form
        ref="form"
        class="ma-auto"
        style="max-width: 320px"
        v-model="formValid"
      >
        <v-checkbox
          class="text-center mt-0 mb-6 mx-auto pt-0"
          label="예, 내용을 이해하였습니다."
          :rules="[gc_rules.required]"
          style="width: 234px"
          dense
        />
        <!--  이메일  -->
        <v-text-field
          label="성명"
          class="rounded-0"
          v-model="form.mail"
          :rules="[gc_rules.required]"
          dense
          outlined
          validate-on-blur
          :disabled="requesting"
          autofocus
        />

        <!--  비밀번호  -->
        <v-text-field
          label="면허번호"
          class="rounded-0"
          v-model="form.pw"
          :rules="[gc_rules.required]"
          @keypress.enter="gm_submitEnter"
          type="text"
          dense
          outlined
          validate-on-blur
          :disabled="requesting"
        />

      </v-form>
    </v-card-text>

    <v-card-actions class="px-4 pt-0 pb-6 d-block">

      <div
        class="ma-auto"
        style="max-width: 320px"
      >
        <v-btn
          ref="submit"
          class="text-h6"
          @click="submit"
          elevation="0"
          color="cyan"
          :dark="!requesting"
          :disabled="requesting"
          :loading="requesting"
          block
          large
          tile
        >{{ gc_langText.common.account.signIn[gc_lang] }}</v-btn>

        <v-btn
          class="mt-6 ml-0 text-h6"
          elevation="0"
          to="/"
          block
          large
          outlined
          tile
        >HOME</v-btn>
      </div>

    </v-card-actions>
  </v-card>
</template>

<script>
export default {
  name: 'Login',

  data: () => ({
    // 폼 입력 데이터
    form: {
      mail: '',
      pw: ''
    },

    // 폼 내부 입력 값들 유효 상태
    formValid: true,

    // 요청 상태
    requesting: false
  }),

  methods: {
    // 폼 입력값 전송
    submit() {
      this.$refs.form.validate()

      if (!this.formValid) { return }

      const params = {
        name: this.form.mail,
        password: this.form.pw
      }

      this.requesting = true

      this.api_signIn(params)
    }
  }
}
</script>

<style lang="sass" scoped>
.box1
  outline: 1px solid #000000
  word-break: keep-all
  p:last-child
    margin-bottom: 0
  .f1
    font-size: 1rem
</style>
